export default __webpack_public_path__ + "static/media/sounds/bd_practice_screen_ready_state.mp3";